import { enhancedApi } from '@store/generated/billing';

const MANAGED_BILLING_TAG_TYPES = ['JotBillManagedBilling', 'MorningWorklist'] as const;

/**
 * Managed billing decides which organizations the Morning Worklist shows by
 * default, so saving it refreshes both the setting and any cached worklist.
 */
export const managedBillingApi = enhancedApi.enhanceEndpoints({
  addTagTypes: MANAGED_BILLING_TAG_TYPES,
  endpoints: {
    getV2AdminOrgsByOrganizationIdJotbillManagedBilling: {
      providesTags: (_result, _error, { organizationId }) => [
        { type: 'JotBillManagedBilling' as const, id: organizationId },
      ],
    },
    getV2AdminBillingDashboardMorningWorklist: {
      providesTags: ['MorningWorklist'],
    },
    patchV2AdminOrgsByOrganizationIdJotbillManagedBilling: {
      invalidatesTags: (_result, _error, { organizationId }) => [
        { type: 'JotBillManagedBilling' as const, id: organizationId },
        'MorningWorklist',
      ],
    },
  },
});
